import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const WordsModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Um orðini" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        ð.fo góðtekur orðini í&nbsp;
        <a
          href="https://bendingar.fo"
          className="underline font-bold"
          target="_blank"
          rel="noopener noreferrer"
        >
          Bendingargrunninum
        </a>
        , herundir eisini nøvn. Hendan broytingin bleiv gjørt 20. august 2025.
      </p>
      <p className="mt-4 text-sm text-gray-500 dark:text-gray-300">
        Áðrenn hesa broyting varð ein gamal orðalisti hjá Orðabókagrunninum
        brúktur. Einstøk vanlig orð mangla í Bendingargrunninum (dømi: ILNAR)
        og einstøk orð, sum eru í vev-útgávuni, eru heldur ikki við í ð.fo (dømi:
        OMMUM), tí tey mangla orðafílunum.
      </p>
      <p className="mt-4 text-sm text-gray-500 dark:text-gray-300">
        Tilfarið verður nýtt við&nbsp;
        <a
          href="https://creativecommons.org/licenses/by-sa/4.0/"
          className="underline font-bold"
          target="_blank"
          rel="noopener noreferrer"
        >
          CC BY-SA 4.0
        </a>
        &nbsp;loyvi.
      </p>
    </BaseModal>
  )
}
